import { CommonHelper } from './../../shared/helpers/CommonHelper';
import { Component, OnInit, HostListener } from '@angular/core';
import { Search } from './../../models/Search.model';
import { ProductService } from './../../services/product.service';
import { Product } from '../../models/billing-letter/Product.model';
import { Json2csvService } from "../../services/json2csv.service";
import { DropDownList } from '../../models/DropDownList.model';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { ProductSearch } from '../../models/ProductSearch.model';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
    loading: boolean;
    products: Product[] = new Array<Product>();
    productsShow: Product[] = new Array<Product>();
    findResults: Search = new Search();
    listProducts: Array<String> = new Array<String>();

    commonHelper: CommonHelper = new CommonHelper();
    productSearchModel: ProductSearch;
    product: Product = new Product();

    dropDownProducts: any;

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 5;
    currentPage: number = 1;

  constructor(
    private productService: ProductService,
    private json2csvService: Json2csvService,
    private localStorage: LocalStorage
  ) { }

  async ngOnInit() {
      this.loading = true;
      //await this.populateProducts();
      this.productSearchModel = this.localStorage.retrieve('products') ? this.localStorage.retrieve('products'):new ProductSearch();
      await this.search();
      this.loading = false;
  }

  persist(){
    let product={
      selectProducts:this.dropDownProducts.selectedItems,
    }
    this.localStorage.persist('product',product);
  }

  retrieve(){
    let product = this.localStorage.retrieve('product');
    if(product){
      this.dropDownProducts.selectedItems = product.selectProducts
    }
  }
  async populateProducts(){
      this.products = await this.productService.getAllProducts();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent){

    if(event.keyCode === 13) {
        this.search(1)
    }
  }

  async search(page?: number) {
    this.loading = true;
    this.currentPage = page ? page : 1;
    this.productSearchModel.skip = (page -1) * this.productSearchModel.limit;
    this.products = await this.productService.searchProduct(this.productSearchModel);
    this.totalItems = this.productSearchModel.totalItems;
    this.localStorage.persist('products', this.productSearchModel);
    this.loading = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/products/products.component.ts